// Nuxt only finds middleware if they're in the directory `middleware`.
// Read more: https://fr.nuxtjs.org/guide/routing#middleware
import staff from '@auth-oauth2/middleware/staff'

export default staff
